// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface IOrganizationPropertiesStatesDto
 */
export interface IOrganizationPropertiesStatesDto {
    /**
     * 
     * @type {{ [key: string]: IFieldStateType; }}
     * @memberof IOrganizationPropertiesStatesDto
     */
    properties?: { [key: string]: IFieldStateType; };
    /**
     * 
     * @type {{ [key: string]: IFieldStateType; }}
     * @memberof IOrganizationPropertiesStatesDto
     */
    overridable_properties?: { [key: string]: IFieldStateType; };
}

/**
 * Check if a given object implements the IOrganizationPropertiesStatesDto interface.
 */
export function instanceOfIOrganizationPropertiesStatesDto(value: object): value is IOrganizationPropertiesStatesDto {
    return true;
}

export function IOrganizationPropertiesStatesDtoFromJSON(json: any): IOrganizationPropertiesStatesDto {
    return IOrganizationPropertiesStatesDtoFromJSONTyped(json, false);
}

export function IOrganizationPropertiesStatesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationPropertiesStatesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'properties': json['properties'] == null ? undefined : (mapValues(json['properties'], IFieldStateTypeFromJSON)),
        'overridable_properties': json['overridable_properties'] == null ? undefined : (mapValues(json['overridable_properties'], IFieldStateTypeFromJSON)),
    };
}

export function IOrganizationPropertiesStatesDtoToJSON(json: any): IOrganizationPropertiesStatesDto {
    return IOrganizationPropertiesStatesDtoToJSONTyped(json, false);
}

export function IOrganizationPropertiesStatesDtoToJSONTyped(value?: IOrganizationPropertiesStatesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'properties': value['properties'] == null ? undefined : (mapValues(value['properties'], IFieldStateTypeToJSON)),
        'overridable_properties': value['overridable_properties'] == null ? undefined : (mapValues(value['overridable_properties'], IFieldStateTypeToJSON)),
    };
}

